module.exports = __webpack_public_path__ + "static/Slider1-5e3053458f7281a040b8e9c3f081456b.jpg";